import React from 'react';
import { Loader2, MessageSquare, RefreshCw, Route } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getAdminTabMeta, AdminTab } from './adminNavigation';

type AdminDesktopContextBarProps = {
  activeTab: AdminTab;
  onOpenRouteUpload?: () => void;
  onShowOwnInbox?: () => void;
  canShowOwnInbox: boolean;
  onRefreshSeoReport: () => void;
  seoReportLoading: boolean;
};

const AdminDesktopContextBar: React.FC<AdminDesktopContextBarProps> = ({
  activeTab,
  onOpenRouteUpload,
  onShowOwnInbox,
  canShowOwnInbox,
  onRefreshSeoReport,
  seoReportLoading
}) => {
  const { t } = useTranslation();
  const ADMIN_TAB_META = getAdminTabMeta(t);
  const activeTabMeta = ADMIN_TAB_META[activeTab];

  return (
    <div className="px-6 py-3 border-b border-[var(--border-primary)] bg-[var(--bg-input)] flex items-center justify-between gap-4 shrink-0">
      <div>
        <p className="text-3xs font-black uppercase tracking-[0.2em] text-[var(--text-muted)]">{t('admin_nav.active_workspace')}</p>
        <p className="text-xs font-black text-[var(--text-primary)] uppercase tracking-widest">{activeTabMeta.label}</p>
      </div>
      <div className="flex flex-wrap justify-end gap-2">
        {(activeTab === 'routes' || activeTab === 'pending') && (
          <button
            onClick={onOpenRouteUpload}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-xl text-3xs font-black uppercase tracking-widest flex items-center gap-2 transition-all active:scale-95 shadow-lg"
          >
            <Route size={13} /> {t('admin_nav.new_route')}
          </button>
        )}
        {activeTab === 'testers' && canShowOwnInbox && (
          <button
            onClick={onShowOwnInbox}
            className="px-3 py-2 bg-emerald-600/20 hover:bg-emerald-600/30 border border-emerald-500/30 text-emerald-300 rounded-xl text-3xs font-black uppercase tracking-widest flex items-center gap-2 transition-all"
          >
            <MessageSquare size={12} />
            {t('admin_nav.my_inbox')}
          </button>
        )}
        {activeTab === 'tools' && (
          <button
            onClick={onRefreshSeoReport}
            disabled={seoReportLoading}
            className="px-3 py-2 bg-[var(--bg-surface-alt)] hover:bg-[var(--bg-surface)] border border-[var(--border-secondary)] text-[var(--text-primary)] rounded-xl text-3xs font-black uppercase tracking-widest flex items-center gap-2 transition-all disabled:opacity-60"
          >
            {seoReportLoading ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />}
            {t('admin_nav.refresh_seo')}
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminDesktopContextBar;
